// extracted by mini-css-extract-plugin
export default {"storyItem":"c-a_fi","storyItem__circle":"c-a_fj","storyItem__image":"c-a_fk","storyItem__description":"c-a_fl","storyItem_viewAll":"c-a_fm"};